module.exports = __webpack_public_path__ + "static/SerifGothicStd-Heavy-03bbc36d9a209f922f813376850da86b.woff";